<!--
 * @Author: Jarun
 * @Date: 2021-03-22 17:06:11
 * @LastEditTime: 2021-04-12 10:46:45
 * @LastEditors: Please set LastEditors
 * @Description: Register
 * @FilePath: \box.mengw.com\src\views\Register\Register.vue
-->

<template>
    <div class="register_index">
        <LoginHeader ref="LoginHeaderRef" />

        <div class="login_wrapper">
            <div class="content login_bg">
                <LoginLogo />
                <div class="register_login_tab">
                    <span v-on:click="changeTab(1)">
                        <p v-bind:class="activeTab === 1 ? 'activeTxt' : ''">手机号登录</p>
                        <b v-bind:class="activeTab === 1 ? 'active' : ''"></b>
                    </span>
                    <i class="register_login_tab__line"></i>
                    <span v-on:click="changeTab(2)" class="">
                        <p v-bind:class="activeTab === 2 ? 'activeTxt' : ''">账号密码登录</p>
                        <b v-bind:class="activeTab === 2 ? 'active' : ''"></b>
                    </span>
                </div>

                <Form class="register_login_form">
                    <div style="overflow: hidden" v-if="activeTab === 1">
                        <IdentifyingInput
                            @changeMobile="getMobile"
                            @changeCaptcha="getCaptcha"
                            @hasUser="hasUser"
                        />

                        <template v-if="!isRealname && false">
                            <div class="pr mt26 mb17 tips_wrap">
                                <i class="register_ver_icon_left real_name"></i>
                                <Field
                                    v-model="realname"
                                    class="common_ring_btn"
                                    label
                                    placeholder="请输入姓名"
                                    autocomplete="off"
                                    @focus="inputFocus('realname')"
                                />
                                <!-- <div class="login_tips">{{ tipsList.realname }}</div> -->
                            </div>

                            <div class="pr tips_wrap">
                                <i class="register_ver_icon_left ic_card"></i>
                                <Field
                                    v-model="idcard"
                                    class="common_ring_btn"
                                    label
                                    autocomplete="off"
                                    placeholder="请输入身份证号"
                                    @focus="inputFocus('idcard')"
                                />
                                <!-- <div class="login_tips">{{ tipsList.idcard }}</div> -->
                            </div>
                        </template>

                        <!-- S 手机注册时未实名号码流程 -->
                        <div class="pr mt17">
                            <div v-on:click="onPhoneSubmit" class="c-button">{{ isRealname ? "登 录" : "注 册" }}</div>
                        </div>
                        <!-- E 手机注册时未实名号码流程 -->
                    </div>

                    <div style="overflow: hidden" v-if="activeTab === 2" class="dropDown">
                        <div class="pr mb17">
                            <i class="register_ver_icon_left icon_user"></i>
                            <Field
                                v-model.trim="username"
                                class="common_ring_btn"
                                label
                                placeholder="请输入账号"
                                autocomplete="off"
                                @focus="inputFocus('username')"
                            />
                            <!-- <img :class="[{register_input_icon_right:true},{down_arrow: !showDropDownAll},{special_img:true}]" src="@/assets/images/mine/icon_more.png" @click.stop="moreLoginData" v-if="loginList&&loginList.length>0"/> -->
                        </div>

                        <div class="dropDownAll" v-show="showDropDownAll">
                            <div class="dropDownAll_content">
                                <div
                                    class="DropdownItem"
                                    v-for="(v, i) in loginList"
                                    :key="v"
                                    @click="inputClickItem(i)"
                                >
                                    <div class="DropdownItem_img">
                                        <img src="@/assets/images/common/icon_logo.png" />
                                    </div>
                                    <div class="DropdownItem_content">
                                        <div>{{ v.user }}</div>
                                        <div>●●●●●●</div>
                                    </div>
                                    <div class="DropdownItem_del" @click.stop="delItem(i)">
                                        <img src="@/assets/images/common/del_icon.png" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pr tips_wrap" style="overflow: hidden">
                            <PasswordInput
                                @changePassword="getPassword"
                                :password="password"
                                placeholder="请输入密码"
                            />
                            <!-- <div class="login_tips">{{ tipsList.username }}</div> -->
                            <a
                                href="javascript:;"
                                class="register_form_small_right_btn"
                                v-on:click="toForget"
                                >忘记密码</a
                            >
                            <!-- <a
                                href="javascript:;"
                                class="register_small_right_btn"
                                v-on:click="toRegister"
                                >注册新账号</a
                            > -->
                        </div>
                        <div class="pr">
                            <div v-on:click="onSubmit" class="c-button">登 录</div>
                        </div>
                    </div>

                    <!-- <div class="pr wx_box" v-if="isWx"></div>
                    <p class="wx_font_box" v-if="isWx">使用第三方登陆</p>
                    <a class="icon_wx" v-if="isWx" v-bind:href="wxHref"></a> -->
                </Form>

                <!-- S 手机一键登录 -->
                <!-- <div class="once_login" v-if="isAndroid">
                    <div class="divider_box">其他方式</div>
                    <div class="icon_box" @click="onAndroid">
                        <div class="phone_icon">
                            <img src="@/assets/images/common/icon_once.png" />
                        </div>
                        <div>手机一键登录</div>
                    </div>
                </div> -->
                <!-- E 手机一键登录 -->

                <!-- S 微信没有绑定账号的弹窗提示 -->
                <div class="no_bing_wx" v-if="showWX">
                    <div class="noBildWX">
                        <a class="closeBtn" v-on:click="closeWX">
                            <img :src="wxclose" />
                        </a>
                        <div class="red_btn">
                            <a href="javascript:;" v-on:click="closeWX">继续浏览</a>
                        </div>
                        <img :src="wxbg" />
                    </div>
                </div>
                <!-- E 微信没有绑定账号的弹窗提示 -->

                <!-- S 用户协议 -->
                <div class="agreement_wrap tips_wrap">
                    <check-agreement
                        v-model:checked="checked"
                        :changeCheck="agree"
                        :phoneTips="activeTab === 1"
                    ></check-agreement>
                    <!-- <div class="tips_msg agreement_tips">{{ tipsList.agreement }}</div> -->
                </div>
                <!-- E 用户协议 -->
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onBeforeMount, onMounted, onUnmounted, computed} from 'vue';
import '@/assets/less/common/tn_code.less';
import { Form, Field, Button, DropdownMenu, DropdownItem, Dialog} from 'vant';
import { useRoute } from "vue-router";
import LoginHeader from '@/components/LoginHeader/LoginHeader.vue';
import LoginLogo from '@/components/LoginLogo/LoginLogo.vue';
import PasswordInput from '@/components/PasswordInput/PasswordInput.vue';
import IdentifyingInput from '@/components/IdentifyingInput/IdentifyingInput.vue';
import CheckAgreement from '@/components/Seven_CheckAgreement/CheckAgreement.vue';
import Util from '@/assets/js/lib/util';
import MonitorKeyboard from '@/assets/js/monitorKeyboard';
import router from '@/router';
import store from '@/store';
import wxbg from '@/assets/images/common/no_bind_wx.png';
import wxclose from '@/assets/images/common/clost_btn.png';
import BScroll from '@better-scroll/core';

export default defineComponent({
    name: 'Register',
    components: {
        LoginHeader,
        LoginLogo,
        Form,
        Field,
        Button,
        PasswordInput,
        IdentifyingInput,
        CheckAgreement,
        DropdownMenu,
        DropdownItem,
        Dialog,
    },
    setup(props, { attrs, slots }) {
        const state = reactive({
            miniapp: '',
            username: '',
            password: '',
            mobile: '',
            captcha: '',
            activeTab: 2,
            isWx: false,
            wxHref: '',
            showWX: false,
            Util: new Util(),
            wxbg: wxbg,
            wxclose: wxclose,
            realname: '', //姓名
            idcard: '', //身份证号
            isRealname: true, //是否存在账号，是否开启实名
            checked: true, //是否已阅读并同意 平台用户协议
            route: useRoute(),
            isAndroid: window.Config.isAndroid, //是否安卓环境
            tipsList: {
                username: '',
                agreement: '',
                realname: '',
                idcard: '',
            },
            bs: '', //上下滚动的插件
            loginBs: '',
            value1:0,
            loginList:[],
            monitorKeyboard: null,
            // dropDownAccountRef:'',
            usernameRef:'',
            saveHeight:0,
            LoginHeaderRef:'',
            showDropDownAll:false,
            sdkInfo: computed(() => store.state.sdkInfo),
        });
        onBeforeMount(async () => {
            state.sdkInfo.isSdkEnv && state.Util.switchAccounts();
        })
        onMounted(() => {
            document.addEventListener('click', methods.bodyCloseMenus);
            state.bs = new BScroll('.login_wrapper',{
                scrollY: true,
                click: true,
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                bounce: false,
            })

            state.loginBs = new BScroll('.dropDownAll',{
                scrollY: true,
                click: true,
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                stopPropagation: true
            })

        })
        onUnmounted(()=>{
            document.removeEventListener('click', methods.bodyCloseMenus);
        })
        const methods = {
            bodyCloseMenus:()=>{
                if(state.showDropDownAll == true){
                    state.showDropDownAll = false
                }
            },
            moreLoginData:()=>{
                state.showDropDownAll = !state.showDropDownAll
                setTimeout(()=>{
                    state.loginBs.scrollTo(0, 0);
                    state.loginBs.refresh();
                },100)
            }
        }

        /* S 获取值 */
        const getPassword = (value) => {
            state.tipsList.username = ''
            state.password = value;
        };
        const getMobile = (value) => {
            state.mobile = value;
        };
        const getCaptcha = (value) => {
            state.captcha = value;
        };
        /* E 获取值 */
        const toForget = (value) => {
            router.push({
                path: 'forget',
                query: router.currentRoute.value.query,
            });
        };
        const toRegister = (value) => {
            router.push({
                path: 'register',
                query: router.currentRoute.value.query,
            });
        };
        const changeTab = (index) => {
            state.activeTab = index;
            state.mobile='';
            state.captcha='';
            state.realname= '';
            state.idcard= '';
            state.username= '';
            state.password= '';
            state.tipsList= {
                username: '',
                agreement: '',
                realname: '',
                idcard: '',
            };
            state.isRealname = true;
            setTimeout(() => {
                state.bs.refresh();
            }, 100);
        }
        /* S 微信 */
        const checkWx = () => {
            if (state.Util.checkUA() == "weixin"){
                state.isWx = true;
            }
        }
        const toWX = async () => {
            const param = {
                app_type: "mp",
                redirect_url: window.location.href,
                api_jump: "1"
            };
            const res = await state.Util.getUserJson('/common/authUrl', 'GET', param, false);

            if (res.code === 1) {
                state.wxHref = res.data.auth_url;
            }
        }
        /* E 微信 */
        const wxLogin = async () => {
            if (state.Util.getUrlParam("code")) {
                let param = {
                    app_type: "mp",
                    wechat_code: state.Util.getUrlParam("code")
                }
                const res = await state.Util.getUserJson('/user/loginByWechat', 'POST', param, false);
                if (res.code === 1) {
                    window.Components.toast('登录成功');
                    store.commit('setUserInfo',res.data)
                    state.Util.setCookie("access_token", res.data.jwt_token);
                    setUserInfo(res);
                    state.Util.statsLogin(2); //登录行为上报
                    state.tipsList.agreement = '';
                } else {
                state.showWX = true;
                }
            }
        }
        const closeWX = () => {
        state.showWX = false;
        }
        onBeforeMount(() => {
          let miniapp = sessionStorage.getItem('miniapp')
            if(miniapp){
              state.miniapp = miniapp
            }
            // checkWx();
            // toWX();
            // wxLogin();

            state.loginList = state.Util.getUserListLocalStorage('userLogin');
            if(state.route.query.type && state.route.query.type == 'user'){
                state.activeTab = 2
            }
        });
        const setUserInfo = async (res) => {
            state.Util.setCookie("access_token", res.data.jwt_token);

            let result = await state.Util.refreshUserInfo();
            if(result.code !== 1){
                state.Util.login()
            }else{
                let arr = {
                    user: result.data.username,
                    pwd: state.password ? state.password : '',
                    nickName: result.data.nickname,
                    t: res.data.jwt_token,
                    vip: result.data.vip,
                    sex: result.data.sex,
                    en: 0
                }
                await state.Util.setUserListLocalStorage('userList', {...arr});
                await state.Util.setUserListLocalStorage('userLogin', {...arr});
                store.commit('setUserInfo',result.data)
                state.Util.judgeJumpUrl();
            }
        }
        const onSubmit = async () => {
            if (state.username === '') {
                window.Components.toast('请输入用户名');
                return false;
            }

            if (state.password === '') {
                window.Components.toast('请输入密码');
                return false;
            }

            if (state.checked === false) {
                window.Components.toast('请先同意《平台用户协议》和《隐私政策》');
                state.tipsList.agreement = '*请先同意《平台用户协议》和《隐私政策》';
                return false;
            }
            const { business_type, platform, game_id } = state.Util.getStatInfo();
            state.Util.clickStat('login_click', {
                login_type: '1',
                account: state.username,
                uid: '',
                phone: '',
                gameid: game_id,
             });
            const param = {
                username: state.username,
                password: state.password,
                login_save:1,
                business_type,
                game_id,
                // channel: report.channel || '',
                platform,
                // device_id: report.device_id || '',
                is_h5: 1,
            };

            window.Components.toast.loading({
                message: '登录中...',
                forbidClick: true,
                duration: 0
            })

            const res = await state.Util.getUserJson('/user/login', 'POST', param, false);
            window.Components.toast.clear();
            if (res.code === 1) {
                window.Components.toast('登录成功');
                setUserInfo(res);
                state.Util.statsLogin(0); //登录行为上报
                state.tipsList.agreement = '';
            // }else if([-4, -2].includes(res.code)){
            //     state.tipsList.username = '*'+ res.msg;
            //     window.Components.toast(res.msg);
            }else {
                window.Components.toast(res.msg);
            }
        };
        const onPhoneSubmit = async () => {

            if (state.mobile == '') {
                window.Components.toast("请输入手机号");
                return false;
            }

            if (!state.Util.CSRegular().phone(state.mobile)) {
                window.Components.toast('请输入正确的手机号');
                return false;
            }

            if (!state.Util.CSRegular().captcha(state.captcha)) {
                window.Components.toast('请输入六位验证码');
                return false;
            }

            // if (!state.isRealname && state.realname == '') {
            //     window.Components.toast("请输入姓名");
            //     state.tipsList.realname = '*请输入姓名';
            //     return false;
            // }

            // if (!state.isRealname && state.idcard == '') {
            //     window.Components.toast("请输入身份证号");
            //     state.tipsList.idcard = '*请输入身份证号';
            //     return false;
            // }

            // if (!state.isRealname && !state.Util.CSRegular().idcard(state.idcard)) {
            //     window.Components.toast('请输入正确的身份证号');
            //     state.tipsList.idcard = '*请输入正确的身份证号';
            //     return false;
            // }

            if (state.checked === false) {
                window.Components.toast('请先同意《平台用户协议》和《隐私政策》');
                state.tipsList.agreement = '*请先同意《平台用户协议》和《隐私政策》';
                return false;
            }
            const { business_type, platform, game_id } = state.Util.getStatInfo();
            if (!state.isRealname) {
                state.Util.clickStat('register_click', {
                    register_type: '0',
                    account: '',
                    uid: '',
                    phone: state.mobile,
                    gameid: game_id,
                });
            } else {
                state.Util.clickStat('login_click', {
                    login_type: '0',
                    account: '',
                    uid: '',
                    phone: state.mobile,
                    gameid: game_id,
                });
            }
            const param = {
                username: state.mobile,
                captcha: state.captcha,
                // realname: state.realname,
                // id_card: state.idcard,
                game_id,
                // channel: report.channel || '',
                platform,
                login_save:1,
                // device_id: report.device_id || '',
                business_type,
                cellphone:1,
                is_h5: 1,
            };
            window.Components.toast.loading({
                message: '登录中...',
                forbidClick: true,
                duration: 0
            })
            const res = await state.Util.getUserJson('/user/captcha_login', 'POST', param, false);
            window.Components.toast.clear();
            if (res.code === 1) {
                window.Components.toast('登录成功');
                setUserInfo(res);
                state.Util.statsLogin(1); //登录行为上报

                state.tipsList= {
                    username: '',
                    agreement: '',
                    realname: '',
                    idcard: '',
                };

            // }else if(res.code == -99){
            //     window.Components.toast(res.msg);
            //     state.tipsList.idcard = '*' + res.msg;
            } else {
                window.Components.toast(res.msg);
            }
        };
        const hasUser = (value) => {
            state.isRealname = value;
            if(!value){
                setTimeout(() => {
                    state.bs.refresh();
                }, 100);
            }
        }
        const agree = () => {
            state.checked = !state.checked;
            state.tipsList.agreement = '';
        };
        const onAndroid = () => {
            try {
                AndroidUtils.localMobleLogin();
            } catch (error) {
                console.info(error);
            }
        }
        const inputFocus = (type) => {
            state.tipsList[type] = '';
            //聚焦于input的时候，登录列表隐藏
            state.showDropDownAll = false;
        };
        const golinkKefu = () => {
            router.push({name: 'customercenter'})
        };

        //点击输入框的右下拉item
        const inputClickItem = (i) => {
            if(state.loginList.length > 0){
                state.username = state.loginList[i].user
                state.password = state.loginList[i].pwd
            }
        };

        //点击输入框的右下拉item删除按钮
        const delItem = (i) => {
            Dialog.confirm({
                title: '温馨提示',
                message: '是否确定删除该账号密码',
            })
            .then(async () => {
                state.Util.delUserListLocalStotage('userLogin',state.loginList[i].user)
                state.loginList = state.Util.getUserListLocalStorage('userLogin');
                setTimeout(()=>{
                    state.loginBs.refresh();
                },100)
            })
            .catch(() => {});
        };

        return {
            onAndroid,
            onSubmit,
            onPhoneSubmit,
            getPassword,
            getMobile,
            getCaptcha,
            toForget,
            toRegister,
            changeTab,
            closeWX,
            hasUser,
            agree,
            inputFocus,
            golinkKefu,
            inputClickItem,
            delItem,
            ...toRefs(state),
            ...methods
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@charset "utf-8";
@import "@/assets/less/common/register.less";
</style>
